import React, { useEffect, useState } from 'react';
import api from '../api/api';

const StudentDashboard = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await api.get('user-profile/'); // Assuming api instance handles token
        setUser(response.data); // Set user data to state
        setLoading(false); // Stop loading
      } catch (error) {
        console.error('Error fetching user profile:', error);
      }
    };

    fetchUserProfile();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <h1>User Profile</h1>
      <p>{user.username}</p>
      <p>{user.email}</p>
      <p>{user.user_type}</p>

      {/* Display the profile image */}
      <img
        src={user.profile_image ? `http://127.0.0.1:8000${user.profile_image}` : '/default-profile.png'}
        alt="Profile"
        style={{ width: '100px', height: '100px', borderRadius: '50%' }}
      />
    </div>
  );
};

export default StudentDashboard;
